export default {
  "custom": {
    linkedReference: '연동 참조',
    boot: '전원 켜기',
    shutDown: '전원 끄기',
    notLinked: '미연동',
    maxLinkedTip: '{type} 연동은 최대 2개까지만 허용되며, 자동으로 미연동으로 되돌려졌습니다',

    bar_Power: '전원 제어',
    bar_Video: '비디오 전환',
    bar_Vol: '볼륨',
    bar_Audio: '오디오 전환',
    bar_Serial: '직렬 제어',
    bar_Air: '에어컨',
    bar_Projection: '스크린',
    bar_Remote: '스크린',
    bar_Matrix: 'IQShare Matrix',
    "youMustSelectAllThreeImagesAtTheSameTime": "세 개의 이미지를 동시에 선택해야 합니다",
    "notSelected": "선택되지 않음",
    "choose": "선택",
    "disable": "사용 안 함",
    "longPressAndDrag": "길게 눌러 드래그하여 목록 순서 조정",
    "isrestoreDefault": "기본 상태로 복원하시겠습니까?",
    "saveAndSync": "저장 및 동기화",
    "restoreDefault": "기본값 복원",
    "limitPNG": "PNG 이미지만 업로드할 수 있습니다!",
    "limit1M": "이미지 크기는 1MB를 초과할 수 없습니다!",
    "selectTheImage": "이미지 선택",
    "textsuggestions": "권장: 48*48 px, 1MB 이하 흰색 PNG 아이콘",
    "iconLibrary": "아이콘 라이브러리",
    "panelNavigationBarCustomization": "패널 내비게이션 바",
    "logoCustomization": "패널 로고"
  },
  "outlook": {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    "AuthVerify4004One": "바인딩 실패: 이 Microsoft 테넌트(ID: ",
    "AuthVerify4004Two": ")는 이미 조직[",
    "AuthVerify4004Three": "]에 의해 사용 중입니다. 재바인딩하려면 먼저 원래 조직에서 바인딩을 해제하거나 다른 Microsoft 테넌트를 사용하세요.",
    "theMicrosoftTenantIsOccupied": "이 Microsoft 테넌트는 사용 중입니다",
    "Viewtutorial": "바인딩 튜토리얼 보기",
    "checktenantID": "테넌트 ID, 애플리케이션 ID 및 애플리케이션 키가 올바른지 확인하세요.",
    "ErrorCode": "오류 코드:",
    "AuthorizationFailed": "인증 실패",
    "Accesshasbeengranted": "Microsoft Graph API 접근이 허용되었습니다",
    "successfullyauthorizedDescribe": "필요한 권한이 성공적으로 승인되었습니다. 회의실 데이터는 자동으로 동기화됩니다. 이 페이지를 닫아주세요.",
    "Close": "닫기",
    "resourceID": "리소스 ID",
    "dialogTips": "팁",
    "theAuthorizationIsDeleted": "승인이 제거되었습니다",
    "theBindingIsSuccessful": "바인딩 성공",
    "theUnbindingIsSuccessful": "바인딩 해제 성공",
    "unbindingFailed": "바인딩 해제 실패",
    "theUnbindingHasBeenUnbound": "바인딩 해제 취소",
    "continueUnbinding": "Outlook 동기화가 중지되고 모든 예정된 이벤트가 삭제됩니다. 바인딩 해제를 계속하시겠습니까?",
    "areYouSureAboutUnbinding": "모든 예정된 Outlook 이벤트가 삭제되고 동기화가 중지됩니다. 이 작업은 되돌릴 수 없습니다. 바인딩 해제를 확인하시겠습니까?",
    "UnbindNotSynchronized": "바인딩 후, 이 회의실의 새 Outlook 이벤트는 자동으로 동기화됩니다(과거 이벤트는 동기화되지 않음)",
    "unbinding": "바인딩 해제",
    "bindUnableToSelect": "이미 바인딩되어 선택할 수 없습니다",
    "permissAThird": "서드파티 리소스를 바인딩하려면 인증하세요",
    "resourceMailbox": "리소스 이메일:",
    "PleasecheckID": "인증 실패! 테넌트 ID, 애플리케이션 ID, 클라이언트 시크릿이 올바른지 확인하세요.",
    "Waitingforauthorization": "인증 대기 중...",
    "Pleasecompletetheauthorization": "Microsoft 365 로그인 페이지가 열렸습니다. 관리자 계정으로 로그인하여 인증을 완료하세요.",
    "pleaseEnterTheTenantID": "테넌트 ID를 입력하세요",
    "pleaseEnterTheClientID": "애플리케이션 ID를 입력하세요",
    "pleaseEnterTheClientSecret": "클라이언트 시크릿을 입력하세요",
    "Authorizationcompleted": "인증 완료",
    "Authorizelogin": "Microsoft 365 로그인 인증",
    "ApplicationID": "테넌트 ID",
    "ClientID": "애플리케이션 ID",
    "ClientSecret": "클라이언트 시크릿",
    "registTipOne": "다음을 따르세요",
    "registTipTwo": "바인딩 가이드",
    "registTipThree": "아래 필드를 입력하기 전에 Azure 앱 등록과 권한 설정을 완료하세요.",
    "MicrosoftDescribe": "Microsoft 365를 바인딩하면 Outlook/Teams에서 예약된 회의를 Q-NEX 콘솔과 룸 스케줄러로 자동 동기화할 수 있습니다.",
    "Addcalendarservice": "캘린더 동기화 설정",
    "Lasttimesynchronization": "마지막 동기화 시간",
    "Allocated": "할당됨",
    "Total": "총계",
    "Conferenceroomresources": "회의실 리소스",
    "Bindingtime": "바인딩 시간",
    "Bindtheplatform": "바인딩 플랫폼",
    "Synchronousstate": "동기화 상태",
    "Organizationname": "조직 이름",
    "Bindthirdpartycalendar": "서드파티 캘린더 바인딩",
    "TenantIDTip": "Azure AD 내 고유 식별자",
    "ApplicationIDTip": "Azure에 등록된 애플리케이션 ID",
    "ApplicationSecretTip": "인증을 위해 Azure에서 생성된 클라이언트 시크릿"
  },
  "meetingManager": {
    IdleDisplayTextTable: '유휴 표시 텍스트',
    IdleDisplayText: '유휴 표시 텍스트:',
    IdleDisplayTextContent: '회의실이 비어 있을 때 표시되는 텍스트 (기본값: “비어 있음”)',

    duplicateMeetingRoomName: '회의실 이름 중복',
    duplicateMeetingRoomNameContent: '"{duplicate_content}" 이름의 회의실이 이미 존재합니다. 다른 이름을 입력해 주세요.',
    "NumberOfRoomPanels": "룸 패널 수",
    "Thecurrentterminalhasbeenboundtoanotherorganization": "현재 단말기는 이미 다른 조직에 바인딩되어 있습니다.",
    "theTerminalNameOrIDIsDuplicated": "패널 이름 또는 ID가 동일합니다",
    theRoomNameOrIDIsDuplicated: '회의실 이름 또는 위치가 중복되었습니다.',
    "AddMeetingRoom": "회의실 추가",
    "EditMeetingRoom": "회의실 편집",
    "MeetingRoomName": "회의실 이름:",
    "Location": "위치:",
    "ReservationApproval": "예약 승인:",
    "ApprovalListYes": "예",
    "ApprovalListNo": "아니요",
    "Capacity": "수용 인원:",
    "RoomStatus": "룸 상태:",
    "BindRoomDisplay": "룸 패널 바인딩:",
    "meeting_btnAdd": "추가",
    "meeting_btnEdit": "편집",
    "meeting_btnBind": "장치 바인딩",
    "meeting_btnDel": "삭제",
    "meeting_tableRoomName": "회의실 이름",
    "meeting_tableRoomPlace": "위치",
    "meeting_tableAppointmentApproval": "예약 승인",
    "meeting_tableCapacityForPeople": "수용 인원",
    "meeting_tableMeetingRoomStatus": "룸 상태",
    "meeting_tableAvaliable": "사용 가능",
    "meeting_tableOutofService": "서비스 중단",
    "meeting_tableDoorBind": "도어 바인딩",
    "meeting_tableBindNPS": "NPS 바인딩",
    "meeting_tableActions": "작업",
    "door_theNameOfTheTerminal": "패널 이름:",
    "door_deviceID": "패널 ID:",
    "door_Wallpaper": "배경화면:",
    "door_Wallpaper_text": "권장 이미지: 크기 1280x800, PNG 형식",
    "door_bindAMeetingRoom": "회의실 바인딩:",
    "door_table_name": "패널 이름",
    "door_table_deviceID": "패널 ID",
    "door_table_status": "상태",
    "door_table_ipAddress": "IP 주소",
    "door_table_bindAMeetingRoom": "회의실 바인딩",
    "door_btnAdd": "추가",
    "door_btnBatchAdd": "일괄 추가",
    "door_btnEdit": "편집",
    "door_btnBatchEdit": "일괄 편집"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "구성 추가",
    "configurationEditTitle": "구성 편집",
    "dialogConfigName": "구성 이름",
    "selectNMPAndNDP": "대상 장치",
    "powerControl": "전원 제어",
    "executeCommand": "실행",
    "tableConfigName": "구성 이름",
    "selectConfig": "구성을 선택하세요"
  },
  "NPS": {
    "Relay": "릴레이",
    "RelaySettings": "릴레이 설정",
    "DevicePower": "장치 전원 제어",
    "DeviceElevation": "승강 제어",
    "LinageWithNPSPower": "NPS 전원 연동",
    "PresentationSwitch": "프레젠테이션 스위치",
    "Duplicate": "복제",
    "LinkagewithNPSPowe": "NPS 전원 연동"
  },
  "PTZ": {
    "powerSupplyON": "전원 켬",
    "powerSupplyOFF": "전원 끔",
    "LEFT": "왼쪽",
    "RIGHT": "오른쪽",
    "UP": "위",
    "DOWN": "아래",
    "HOME": "홈",
    "ENLARGE": "확대",
    "REDUCTION": "축소",
    "StopMovement": "이동 중지",
    "STOP": "줌 중지",
    "FOCUS": "초점",
    "SET_PRESETS0": "프리셋0 설정",
    "SET_PRESETS1": "프리셋1 설정",
    "SET_PRESETS2": "프리셋2 설정",
    "SET_PRESETS3": "프리셋3 설정",
    "SET_PRESETS4": "프리셋4 설정",
    "SET_PRESETS5": "프리셋5 설정",
    "SET_PRESETS6": "프리셋6 설정",
    "SET_PRESETS7": "프리셋7 설정",
    "SET_PRESETS8": "프리셋8 설정",
    "SET_PRESETS9": "프리셋9 설정",
    "USE_PRESETS0": "프리셋0 사용",
    "USE_PRESETS1": "프리셋1 사용",
    "USE_PRESETS2": "프리셋2 사용",
    "USE_PRESETS3": "프리셋3 사용",
    "USE_PRESETS4": "프리셋4 사용",
    "USE_PRESETS5": "프리셋5 사용",
    "USE_PRESETS6": "프리셋6 사용",
    "USE_PRESETS7": "프리셋7 사용",
    "USE_PRESETS8": "프리셋8 사용",
    "USE_PRESETS9": "프리셋9 사용"
  },
  "schedule": {
    "startLinkPowerStart": "전원 켬 (CBX 릴레이)",
    "startLinkPowerStop": "전원 끔 (CBX 릴레이)",
    "dehumidification": "제습",
    "airSupply": "송풍",
    "masterControl": "메인:",
    "powerSupply": "전원",
    "lockScreen": "잠금",
    "RecordingControl": "녹화 제어",
    "RecordingControlSystem": "강의 캡처 시스템",
    "LiquidCrystal": "인터랙티브 플랫 패널",
    "projector": "프로젝터",
    "othertype": "기타",
    "childLock": "차일드락",
    "energySaving": "절전",
    "signalSourceSwitching": "입력 소스",
    "other": "기타 기능:",
    "otherFunction": "기능",
    "send": "전송",
    "ON": "켜기",
    "OFF": "끄기",
    "btnAddSchedule": "복원",
    "EditSchedulelist": "스케줄러 편집",
    "AddSchedulelist": "스케줄러 추가",
    "RestoreSchedulelist": "복원",
    "btn": "취소",
    "btnNewList": "새 스케줄러",
    "ListName": "이름",
    "Cannotquit": "필수",
    "NOCannotquit": "아니오",
    "ListValidityPeriod": "유효 기간",
    "ListDescription": "설명",
    "currentSchedule": "스케줄러 목록",
    "historySchedule": "히스토리 목록",
    "selectTime": "시간",
    "taskType": "작업 유형",
    "selectBroadcasting": "방송",
    "selectDeviveControl": "장치 제어",
    "newSchedule": "새 작업",
    "newChecklist": "새 체크리스트",
    "titleStatus": "상태",
    "titleType": "유형",
    "titleStartTime": "시작 시간",
    "titleEndTime": "종료 시간",
    "titleRepeat": "반복",
    "titleName": "이름",
    "titleAction": "작업",
    "tableEnabled": "활성",
    "tablePaused": "일시정지",
    "tableEdit": "편집",
    "tableDelete": "삭제",
    "tableVolumeEdit": "방송 볼륨",
    "tableBroadcastTitle": "제목",
    "tableBroadcastContent": "내용",
    "tableBroadcastList": "목록",
    "tableBroadcast": "강제",
    "btnRemoveCompletely": "완전히 제거",
    "btnEnabled": "활성 작업",
    "btnPaused": "일시정지",
    "btnDelete": "삭제",
    "repeat0": "월",
    "repeat1": "화",
    "repeat2": "수",
    "repeat3": "목",
    "repeat4": "금",
    "repeat5": "토",
    "repeat6": "일",
    "dialogTitleAdd": "새 장치 제어 작업",
    "dialogTitleEdit": "장치 제어 작업 편집",
    "newBroadcastingSchedule": "새 방송 작업",
    "editBroadcastingSchedule": "방송 작업 편집",
    "chooseDevice": "장치 선택",
    "timeSetting": "시간 설정",
    "controlBroadcasting": "방송 옵션",
    "controlOption": "제어 옵션",
    "scheduleName": "작업 이름:",
    "destination": "대상",
    "timeTilte": "시간",
    "repeatTitle": "반복",
    "dialogRepeat0": "월",
    "dialogRepeat1": "화",
    "dialogRepeat2": "수",
    "dialogRepeat3": "목",
    "dialogRepeat4": "금",
    "dialogRepeat5": "토",
    "dialogRepeat6": "일",
    "dialogOnceType": "한 번",
    "dialogRepeatType": "반복",
    "mainPower": "메인 전원",
    "powerControl": "전원 제어",
    "tableDisplayInputSwitch": "디스플레이 입력 전환",
    "tableAirConditioning": "에어컨",
    "tableProjectionScreen": "투사 화면",
    "tableElectronicLock": "전기 잠금장치",
    "interactiveFlatPanel": "Interactive Flat Panel",
    "displayInputSwitch": "디스플레이 입력 전환",
    "speakerVolume": "스피커 볼륨",
    "MICVolume": "마이크 볼륨",
    "ProjectionScreen": "투사 화면",
    "ElectronicLock": "전기 잠금장치",
    "AirConditioning": "에어컨",
    "AirConditioningPower": "전원",
    "AirConditioningModel": "모델",
    "AirConditioningTEMP": "온도",
    "AirConditioningFanSpeed": "팬 속도",
    "OPEN": "열기",
    "CLOSE": "닫기",
    "UP": "위",
    "DOWN": "아래",
    "PowerOFF": "끄기",
    "PowerON": "켜기",
    "ModelAuto": "자동",
    "ModelCool": "냉방",
    "ModelHeat": "난방",
    "ModelAir": "공기 측",
    "TEMPLow": "낮음",
    "TEMPMiddle": "중간",
    "TEMPHigh": "높음",
    "btnSave": "저장",
    "btnNext": "다음",
    "StartTime": "시작 시간",
    "StopTime": "종료 시간",
    "Mandatory": "필수",
    "Video": "영상&오디오",
    "Notification": "알림",
    "btnFile": "미디어 파일 선택",
    "LastingTime": "지속 시간",
    "textTitle": "제목",
    "textContent": "내용",
    "textTitleLetters": "60자 미만",
    "textContentLetters": "320자 미만",
    "CannotquitYES": "예",
    "CannotquitNo": "아니오",
    "YES": "예",
    "No": "아니오",
    "delTitleContent": "이 스케줄러를 삭제하시겠습니까?",
    "delTitleListContent": "삭제된 스케줄러는 히스토리 목록으로 이동되며 복원할 수 있습니다",
    "deleListTitle": "스케줄러를 삭제하시겠습니까?",
    "delTitleListContent1": "스케줄러를 삭제하면 관련 작업도 제거됩니다. 확인해주세요.",
    "deleListTitle1": "이 스케줄러를 삭제하시겠습니까?",
    "delTitle": "삭제?",
    "btnConfirm": "확인",
    "coxAll": "전체",
    "coxBroadcasting": "방송",
    "coxDeviveControl": "장치 제어",
    "rdMandatory": "예",
    "noRdMandatory": "아니오",
    "startDate": "시작일",
    "endedDate": "종료일",
    "or": "-",
    "broadcastingType": "유형",
    "ChooseTime": "시간 선택",
    "ChooseDate": "날짜 선택",
    "newScheduleList": "새 스케줄러",
    "editScheduleList": "스케줄러 편집",
    "listName": "이름",
    "listValidityPeriod": "유효 기간",
    "listDescription": "설명",
    "cancel": "취소",
    "confirm": "확인",
    "save": "저장",
    "addSuccess": "추가 성공!",
    "addError": "추가 실패!",
    "editSuccess": "편집 성공!",
    "editError": "편집 실패!",
    "delSuccess": "삭제 성공!",
    "delError": "삭제 실패!",
    "restoreSuccess": "스케줄 목록 복원 성공",
    "restoreError": "스케줄 목록 복원 실패",
    "restoreTitleContent": "이 시간은 목록의 스케줄과 충돌합니다. 다시 선택해주세요",
    "Enabled": "활성",
    "Paused": "일시정지",
    "Title": "제목:",
    "Content": "내용:",
    "errorScheduleNameRequired": "작업 이름을 입력해야 합니다",
    "errorDeviceRequired": "대상 장치를 선택해주세요",
    "deleTitle": "이 작업을 삭제하시겠습니까?",
    "loopList": "루프 목록",
    "errorPleaseDateRange": "날짜 범위를 선택해주세요",
    "addError_2009": "중복된 스케줄러 이름",
    "conflicts": "작업 시간이 다음과 충돌합니다:",
    "Pleaseagain": "다시 입력해주세요",
    "errorScheduleName": "작업 이름",
    "errorListName": "스케줄러 이름",
    "today": "오늘",
    "yesterday": "어제",
    "thisWeek": "이번 주",
    "lastWeek": "지난주",
    "lastMonth": "지난달",
    "thisMonth": "이번 달",
    "times": "횟수",
    "TimeConflicts": "시간 충돌",
    "editError_2006": "장치를 찾을 수 없음",
    "editError_2010": "중복 작업 이름",
    "ListTimeExpired": "스케줄러 시간이 만료되었습니다. 다시 선택해주세요",
    "TimeExpired": "시간 만료",
    "ControlOption": "제어 옵션이 없습니다",
    "Pleaseleastone": "적어도 하나의 제어 옵션을 선택해주세요",
    "Enter": "입력",
    "TitleFilled": "제목은 필수입니다",
    "ContentFilled": "내용은 필수입니다",
    "PleaseMediaFile": "미디어 파일을 선택해주세요",
    "PleaseSchedule": "작업을 선택해주세요",
    "delTitleScheduleContent": "삭제된 작업은 복원할 수 없습니다",
    "deleTitleSchedule": "이 작업을 삭제하시겠습니까?",
    "deleteScheduleTitle": "삭제할 작업을 선택해주세요",
    "PleaseFillColumn": "스케줄러 이름을 입력해주세요",
    "PleaseDate": "날짜를 선택해주세요",
    "Previous": "이전",
    "RemoteControl": "리모컨",
    "taskhasexpired": "이 작업은 만료되었습니다. 생성자에게 시간을 업데이트하도록 문의하세요.",
    "execute": "실행",
    "broadcastingList": "방송 목록",
    "volumeSuccess": "볼륨 설정 성공",
    "volumeFailed": "볼륨 설정 실패"
  },
  "Automation": {
    "nameDuplicate": "자동 작업 이름 중복",
    "Automation": "자동화",
    "if": "만약:",
    "ifContent": "IF' 섹션에서는 센서 데이터를 기반으로 조건을 설정할 수 있습니다. 센서를 선택하고 '온도 > 26°C'와 같은 조건을 지정하세요.",
    "then": "그러면:",
    "thenContent": "THEN' 섹션에서는 장치를 선택하고 작업을 정의할 수 있습니다. NMP1, NMP2 같은 장치를 선택하고 에어컨의 경우 '켜기 + 냉방' 같은 작업을 지정하세요.",
    "btnDelete": "삭제",
    "Add": "추가",
    "taskName": "작업 이름",
    "dialogTaskName": "작업 이름:",
    "Statue": "상태",
    "DevicesApplied": "적용된 장치",
    "Operation": "작업",
    "AirConditioningPower": "전원",
    "AirConditioningModel": "모델",
    "AirConditioningFanSpeed": "팬 속도",
    "bold": "스윙",
    "selectTask": "작업을 선택하세요",
    "autoTaskAdd": "자동화 작업 추가",
    "autoTaskEdit": "자동화 작업 편집",
    "Destination": "대상",
    "selectConditions": "실행할 작업을 지정해주세요.",
    "selectDestination": "대상 NMP 장치를 선택한 후, 실행할 작업을 지정해주세요",
    "AirConditioningTEMP": "온도",
    "AirConditioningHumidness": "습도",
    "noData": "아직 작업이 추가되지 않았습니다. \"추가\" 버튼을 클릭하여 작업을 추가하세요."
  },
  "rs232Translation": {
    "reliveBinding": "바인딩 해제",
    "RELIVEBINDING": "바인딩 해제",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "CBX 이름을 입력해야 합니다",
    "BrandNoNull": "브랜드를 입력해야 합니다",
    "ModelNoNull": "모델을 입력해야 합니다",
    "AcNoNull": "에어컨 제어를 입력해야 합니다",
    "RcNoNull": "리모컨을 입력해야 합니다"
  },
  "route": {
    "customize": "사용자 정의",
    "InputSourcesLinkage": "입력 소스 연동",
    "Automation": "자동화",
    "dashboard": "Dashboard",
    "i18n": "I18n",
    "organizationMge": "그룹",
    "userMge": "사용자",
    "authorityMge": "권한",
    "roleMge": "역할",
    "equipmentMge": "장치",
    "workstationMge": "미디어 서버",
    "cloudDiskMge": "스토리지 제어",
    "operationLog": "작업 로그",
    "setting": "설정",
    "resourceMge": "리소스 관리",
    "storageMge": "스토리지 관리",
    "interfaceRename": "인터페이스 이름 변경",
    "processorManager": "프로세서 관리자",
    "projectorCode": "시리얼 코드 관리",
    "projectorCodeSetting": "시리얼 코드 설정",
    "RepairLog": "수리 로그",
    "remoteControl": "리모컨 코드",
    "acCode": "에어컨 제어 코드",
    "cardMge": "카드",
    "cardLog": "카드 사용 로그",
    "cardManager": "카드 관리자",
    "meetingManager": "회의",
    "meetingRoomManager": "회의실 관리",
    "meetingDoorManager": "패널 관리"
  },
  "navbar": {
    "logOut": "로그아웃",
    "dashboard": "대시보드",
    "screenfull": "전체 화면",
    "language": "언어",
    "userConsole": "Q-NEX 콘솔",
    "BackTianwa": "Tianwa로 돌아가기"
  },
  "feedback": {
    "Feedback": "피드백",
    "email": "피드백을 위해 이메일을 남겨주세요.",
    "content": "제품 개선을 위한 메시지를 환영합니다. 의견 감사합니다.",
    "submit": "제출",
    "emailNoEmpty": "이메일을 입력해야 합니다",
    "emailTrueRule": "올바른 이메일 형식을 입력하세요",
    "contentNoEmpty": "내용을 입력해야 합니다",
    "feedbackSuccess": "피드백 성공",
    "feedbackFailed": "피드백 실패",
    "emailNoChinese": "메일박스에 한자를 포함할 수 없습니다",
    "emailLength": "5~100자 사이여야 합니다",
    "GroupNameLength": "1~20자 사이여야 합니다",
    "emailSpecialString": "이 입력란에는 특수 문자열을 포함할 수 없습니다"
  },
  "login": {
    "title": "환영합니다",
    "logIn": "로그인",
    "username": "사용자 이름",
    "password": "비밀번호",
    "any": "선택 사항",
    "thirdparty": "또는 다음으로 연결",
    "thirdpartyTips": "로컬에서 시뮬레이션할 수 없습니다. 자체 비즈니스 시뮬레이션과 결합하세요!",
    "placeholder": "[\r\n  \"사용자 이름\",\r\n  \"비밀번호\",\r\n  \"인증 코드\"\r\n]",
    "userNameTitle": "잘못된 사용자 이름!",
    "forget": "잊으셨나요?",
    "loginTitle0": "로그인 성공!",
    "loginTitle1000": "사용자 이름 또는 비밀번호가 잘못되었습니다!",
    "loginTitle1001": "사용자 이름과 비밀번호를 입력해야 합니다!",
    "loginTitle1002": "인증 코드를 입력해야 합니다!",
    "loginTitle1003": "사용자 상태가 잘못되어 로그인에 실패했습니다!",
    "loginTitle1004": "인증 코드 오류!",
    "loginTitle1005": "로그인하지 않았습니다. 먼저 로그인하세요!",
    "loginTitleUserName": "사용자 이름을 입력하세요!",
    "loginTitlePwd": "비밀번호를 입력하세요!",
    "loginTitleVercode": "인증 코드를 입력하세요!",
    "errorLogin": "사용자 권한이 부족하여 로그인할 수 없습니다!",
    "titleLoginNameFormat": "문자 또는 문자와 숫자로 구성되어야 합니다."
  },
  "organizationMge": {
    "CanTDragTop": "루트로 이동할 수 없습니다",
    "prefixCannotBeEmpty": "슈퍼 관리자 계정 접두사는 비워둘 수 없습니다",
    "enterEnglishLetters": "슈퍼 관리자 계정 접두사는 영문자와 숫자만 입력할 수 있습니다",
    "dateNotSelected": "스트리밍 서비스 유효기간 시작일이 선택되지 않았습니다",
    "btnAddChild": "하위 추가",
    "btnAddSibling": "동급 추가",
    "title": "팁:",
    "againTitle": "다시 확인하십시오:",
    "sort": "정렬:",
    "realName": "실명:",
    "titleShooleRq": "이 필드는 필수입니다",
    "titleShooleNub": "100자 미만",
    "schoolName": "그룹 이름:",
    "type": "그룹 유형:",
    "accountPrefix": "관리자 계정:",
    "organization": "배포자",
    "terminalMechanism": "최종 사용자",
    "equipmentNum": "장치 번호:",
    "organizationNum": "단말 그룹 번호:",
    "adminName": "관리자 계정:",
    "adminPwd": "관리자 비밀번호:",
    "edit": "편집",
    "add": "추가",
    "del": "삭제",
    "addSuccess": "추가 성공",
    "addError": "추가 실패!",
    "editSuccess": "수정 성공",
    "editError": "수정 실패!",
    "delSuccess": "삭제 성공!",
    "delWarn": "바인딩된 장치가 있는 그룹은 삭제할 수 없습니다",
    "delError": "삭제 실패!",
    "cancel": "취소",
    "confirm": "확인",
    "save": "저장",
    "TrialWorkstation": "현재 시험 상태로, 최대 3개의 단말 장치만 방송 및 라이브 스트리밍을 전송할 수 있습니다.",
    "Normal": "일반",
    "NormalWorkstation": "스트리밍 서비스 유효기간은 다음과 같습니다",
    "to": "까지",
    "Advent": "시작  ",
    "AdventWorkstationOne": "스트리밍 서비스가 에 만료됩니다",
    "AdventWorkstationTwo": "정상 사용을 위해 제때 에이전트에게 갱신 요청을 해주세요.  ",
    "Expired": "만료  ",
    "ExpiredWorkstation": "스트리밍 서비스가 만료되었습니다. 에이전트에게 갱신 요청을 해주세요.  ",
    "admin": "관리자:  ",
    "serviceState": "스트리밍 미디어 서비스:  ",
    "serviceStateLIST": "스트리밍 미디어 서비스  ",
    "ValidityPeriod": "유효기간:  ",
    "ValidityPeriodLIST": "유효기간  ",
    "Trial": "체험  ",
    "Permanent": "영구  ",
    "AnnualBilling": "연간 청구  ",
    "mediaValidityPeriod": "유효기간:  ",
    "mediaValidityPeriodLIST": "유효기간  ",
    "contactInformation": "연락처(스트리밍 서비스 갱신 알림용)  ",
    "company": "회사 이름:  ",
    "email": "이메일:  ",
    "phone": "전화:  ",
    "StartDate": "시작일  ",
    "EndDate": "종료일",
    "To": "까지",
    "TerminalName": "최종 사용자 이름  ",
    "Competence": "관리자  ",
    "operate": "작업  ",
    "statusFilter": "상태 필터  ",
    "disableStreaming": "스트리밍 서비스를 비활성화하시겠습니까?  ",
    "enableStreaming": "스트리밍 서비스를 활성화하시겠습니까?  ",
    "disableStreamingContent": "스트리밍 서비스가 비활성화되면, 그룹은 방송 및 라이브 방송 관련 기능을 사용할 수 없습니다.  ",
    "enableStreamingContent": "만료된 스트리밍 서비스 그룹의 유효 기간을 수정하십시오.  ",
    "search": "조직 이름을 입력하세요  ",
    "optionsYearZero": "선택해주세요  ",
    "optionsYearOne": "1년  ",
    "optionsYearTwo": "2년  ",
    "optionsYearThree": "3년  ",
    "dialogName": "이름:  ",
    "detTitle": "그룹을 삭제하면 해당 그룹 아래의 모든 콘텐츠도 함께 삭제됩니다.  ",
    "groupDelTitle": "이 그룹을 삭제하시겠습니까?  ",
    "delTitle": "삭제?  ",
    "delTitleContent": "선택한 내용이 데이터베이스에서 삭제됩니다. 이 작업은 되돌릴 수 없습니다. 계속하시겠습니까?  ",
    "delCancelButton": "취소  ",
    "delConfirmButton": "확인  ",
    "copySuccess": "내용이 클립보드에 복사되었습니다.  ",
    "copyError": "브라우저가 자동 복사를 지원하지 않습니다  ",
    "error1200": "그룹 이름 중복  ",
    "error1201": "그룹 또는 그룹 ID 중복  ",
    "error1202": "연결 가능한 장치 수를 초과했습니다  ",
    "error1203": "사용자 이름 중복  ",
    "error1204": "같은 수준에 동일한 이름의 그룹이 있습니다  ",
    "error1210": "관리자 비밀번호를 입력하세요  ",
    "warningGroup": "그룹을 선택하세요!  ",
    "warningTerminal": "터미널 그룹은 하위 그룹을 생성할 수 없습니다!  ",
    "account": "계정 중복  ",
    "titleOrganization": "참고: 처음 몇 글자는 조직의 통일 접두사이며, 조직 내 모든 사용자 계정은 이 접두사를 동일하게 사용합니다.  ",
    "all": "모두"
  },
  "userMge": {
    "nickName": "닉네임  ",
    "contentWithBrand": "브랜드 또는 모델 입력  ",
    "contentwithIp": "디바이스 이름 또는 IP 주소로 검색  ",
    "btnAdd": "새 사용자  ",
    "btnDelete": "삭제  ",
    "btnDownload": "템플릿 다운로드  ",
    "btnImport": "일괄 가져오기  ",
    "btnExport": "다운로드  ",
    "btnDisable": "사용 안 함  ",
    "btnEnable": "사용  ",
    "accountType": "역할로 필터  ",
    "organizationName": "그룹으로 필터  ",
    "content": "검색  ",
    "systemAccount": "사용자 ID  ",
    "idCardNumber": "사번  ",
    "customizeAccount": "커스텀 계정  ",
    "userName": "이름  ",
    "licenseNum": "라이선스 번호  ",
    "phone": "전화번호  ",
    "email": "이메일  ",
    "role": "역할  ",
    "status": "상태  ",
    "affiliatedOrganization": "그룹  ",
    "roleTypeList1": "일반 사용자  ",
    "roleTypeList2": "학생  ",
    "roleTypeList3": "보호자  ",
    "roleTypeList101": "에이전트 관리자  ",
    "roleTypeList102": "관리자  ",
    "roleTypeList301": "슈퍼 관리자  ",
    "userStatus1": "활성  ",
    "userStatus2": "차단  ",
    "userStatus3": "삭제  ",
    "operate": "작업  ",
    "dialogName": "닉네임:  ",
    "dialogUserName": "사용자 ID:  ",
    "dialogUserNameDefined": "사용자 이름:  ",
    "dialogPassword": "비밀번호:  ",
    "dialogID": "사번:  ",
    "dialogRole": "역할:  ",
    "dialogEmail": "이메일:  ",
    "dialogPhone": "전화번호:  ",
    "dialogGroup": "그룹:  ",
    "addUser": "새 사용자  ",
    "editUser": "사용자 편집  ",
    "addSuccess": "추가 성공!  ",
    "addError": "추가 실패!  ",
    "editSuccess": "편집 성공!  ",
    "editError": "편집 실패!  ",
    "delSuccess": "삭제 성공!  ",
    "delError": "삭제 실패!  ",
    "cancel": "취소  ",
    "confirm": "확인  ",
    "save": "저장  ",
    "tableDel": "삭제  ",
    "tableEdit": "편집  ",
    "selectRoles": "역할 선택  ",
    "delTitle": "삭제?  ",
    "delTitleContent": "선택한 내용이 데이터베이스에서 삭제됩니다. 이 작업은 되돌릴 수 없습니다. 계속하시겠습니까?  ",
    "delCancelButton": "취소  ",
    "delConfirmButton": "확인  ",
    "titleRealNameRq": "이 필드는 필수입니다  ",
    "titleRealNameFormat": "영문자와 숫자만 포함된 사용자 이름을 선택하세요.  ",
    checkPasswordTitleTwo: '비밀번호는 6자 이상으로 설정하고, 영문자와 숫자를 포함해야 합니다. 특수문자는 제한 없이 사용할 수 있습니다.',
    checkPasswordTitle: '비밀번호는 최소 6자 이상이며 숫자만 사용할 수 없습니다',
    "titlePhoneFormat": "전화번호는 숫자, () + -만 입력 가능합니다.  ",
    "phoneFilled": "전화번호는 필수입니다.  ",
    "titleEmaileFormat": "이메일 형식 오류  ",
    "emaileFilled": "이메일은 필수입니다.  ",
    "titlUserNameDefinedNub": "사용자 이름은 30자를 초과할 수 없습니다  ",
    "titlRealNameNub": "이름은 30자를 초과할 수 없습니다  ",
    "titlRealNameField": "이름은 필수입니다  ",
    "thisPasswordField": "비밀번호는 필수입니다  ",
    "titlPassWordNub": "비밀번호는 6~30자여야 합니다  ",
    "enableStatus": "사용자 활성화  ",
    "stopStatus": "사용자 비활성화  ",
    "enableContent": "사용자를 활성화하시겠습니까?  ",
    "stopContent": "사용자를 비활성화하시겠습니까?  ",
    "error1400": "사용자 이름이 이미 존재합니다. 다시 시도하세요  ",
    "error1401": "사용자 ID가 이미 존재하며 작업 실패!  ",
    "error1402": "그룹이 존재하지 않아 가져오기 실패!  ",
    "error1403": "데이터가 잘못되었습니다  ",
    "error1404": "권한 부족  ",
    "selUser": "사용자를 선택하세요!  ",
    "error1405": "역할 가져오기 실패  ",
    "error1406": "가져온 사용자 정보 데이터 형식이 올바르지 않습니다  ",
    "error1407": "이메일이 이미 존재하여 작업 실패  ",
    "error1408": "전화번호가 이미 존재하여 작업 실패  ",
    "error1900": "접근한 매개변수가 비어 있습니다  ",
    "error1610": "관련 작업을 수행하려면 단말기 관리자 역할을 사용하세요  ",
    "errorOrgIdList": "그룹은 비어 있을 수 없습니다!  ",
    "Bindsucceeded": "바인딩 성공  ",
    "Bindfailed": "바인딩 실패  ",
    "tableuserName": "사용자 이름  ",
    "titleDevice": "디바이스  ",
    "bindDevice": "디바이스 바인딩  ",
    "Bindcontrollable": "지금 제어 가능한 디바이스를 바인딩하시겠습니까?"
  },
  "devicesMge": {
    "mustChooseOne": "스마트 리모컨이 선택된 경우, 최소 하나의 제어 명령을 선택해야 합니다  ",
    "customName": "사용자 정의 이름  ",
    "testAcCode": "새 A/C 제어 코드 테스트  ",
    "Online": "온라인  ",
    "Offline": "오프라인  ",
    "unBindConfirm": "시리얼 바인딩 해제 확인  ",
    "unBindConfirm485": "RS485 바인딩 해제 확인  ",
    "notYetBoundRS232": "장치가 아직 시리얼 코드에 바인딩되지 않았습니다. [장치 > 시리얼 제어 코드]에서 추가할 수 있습니다.  ",
    "RsFollowingFunctions": "시리얼 코드를 통해 다음 기능을 수행할 수 있습니다:  ",
    "Unbind": "바인딩 해제  ",
    "Limit255": "파일 이름은 최대 255자까지 가능합니다  ",
    "clear": "지우기  ",
    "equipName": "장치 이름  ",
    "equipType": "유형  ",
    "selectField": "파일을 선택하세요  ",
    "dialogTip": "*오른쪽 입력란이 비어있으면 왼쪽 내용이 기본으로 표시됩니다  ",
    "dialogTipSingle": "*단일 장치에 이름이 없는 경우 \"ALL\" 이름을 따릅니다",
    "cantDelTemplateOne": "\" \" CBX",
    cantDelTemplateTwo: '"{deviceName}" 장치의 CBX는 템플릿입니다. 삭제하시겠습니까?',
    "templateTitle": "템플릿 교체",
    "templateContentOne": "장치 이름 \"",
    "templateContentTwo": "\"은(는) 공용 CBX 템플릿으로 설정되어 있습니다. 현재 장치를 템플릿으로 설정하시겠습니까?",
    "vcbNoTemplateNoSave": "템플릿이 없으면 저장할 수 없습니다",
    "vcbAcControl": "A/C 장치 선택",
    "vcbRemoteControl": "리모컨 장치 선택",
    "vcbPOWERControl": "전원 제어",
    "vcbRS232Control": "시리얼 제어",
    "vcbIRControl": "IR 제어",
    "vcbSetting": "CBX 설정",
    "editVcb": "CBX 편집",
    "vcbName": "CBX 이름",
    "iot": "CBX 제어",
    "saveAsTemplate": "템플릿으로 저장",
    saveAsTemplatereplenish: '제어 센터에서 이 템플릿을 사용할 여러 장치를 선택하세요',
    "Upload": "업로드",
    "Select": "선택",
    "InputDeviceID": "장치 ID 입력",
    "editNameTips": "* 오른쪽 입력란이 비어 있으면 왼쪽 내용이 기본으로 표시됩니다.",
    "_RS232A": "인터페이스 1",
    "_RS232B": "인터페이스 2",
    "institutionDirectory": "기관 디렉터리",
    "projectionScreenLinkageSetting": "프로젝션 스크린 제어 설정",
    "screenLiftingLinkageDisplaySwitch": "프로젝션 스크린 및 디스플레이 연동 제어:",
    "stopLinkage": "사용 안함(프로젝션 스크린 별도 제어)",
    "Enable": "사용(프로젝션 스크린과 디스플레이 동기 제어)",
    "btnAddDevice": "장치 추가",
    "btnImportDevice": "장치 일괄 가져오기",
    "btnDel": "삭제",
    "btnEdit": "편집",
    "tableIpAddress": "IP 주소",
    "MACAddress": "MAC 주소",
    "firmwareVersion": "펌웨어 버전",
    "NA": "해당 없음",
    "tableDeviceName": "장치 이름",
    "tableStatus": "상태",
    "tableVideoSwitch": "비디오 스위치",
    "tableAudio": "A/V 분배",
    "tablePowerControl": "전원 제어",
    "tableRS232": "시리얼 제어",
    "tableIR": "IR 제어",
    "tableRFIDCard": "IC 카드",
    "tableControlPanel": "제어 패널",
    "tableOrganization": "그룹",
    "tableActions": "작업",
    "dialogAddTitle": "장치 추가",
    "dialogEditTitle": "장치 편집",
    "dialogBatchAddTitle": "장치 일괄 추가",
    "dialogBatchEditTitle": "장치 일괄 편집",
    "btnCancel": "취소",
    "Devices": "장치:",
    "ProjectorCode": "시리얼 코드:",
    "Group": "그룹:",
    "btnBatchAdd": "일괄 추가",
    "delTitle": "삭제?",
    "delTitleContent": "선택한 구성 요소는 데이터베이스에서 삭제됩니다. 이 작업은 취소할 수 없습니다. 계속하시겠습니까?",
    "delCancelButton": "취소",
    "delConfirmButton": "확인",
    "addError": "추가 실패!",
    "editSuccess": "편집 성공!",
    "editError": "편집 실패!",
    "delSuccess": "삭제 성공!",
    "delError": "삭제 실패!",
    "content": "검색",
    "cancel": "취소",
    "confirm": "확인",
    "save": "저장",
    "tableDel": "삭제",
    "tableEdit": "편집",
    "selectRoles": "역할 선택",
    "selectType": "유형을 선택하십시오",
    "selectDevices": "장치를 선택하십시오",
    "titleRealNameRq": "이 필드는 필수입니다",
    "titleRealNameNub": "100자 미만",
    "titlPassWordNub": "15자 미만",
    "error1900": "접근한 매개변수가 비어 있습니다",
    "error2000": "연결 가능한 장치 수를 초과했습니다",
    "error2001": "가져온 장치 코드가 잘못되었거나 시스템에 아직 입력되지 않았습니다.",
    "error2002": "중복된 장치 이름이 가져오기되었습니다",
    "error2003": "가져온 장치 ID가 이미 사용되었습니다",
    "error2004": "데이터 가져오기 오류",
    "error2005": "브랜드 또는 모델 이름이 기존 데이터와 중복됩니다. 브랜드 또는 모델 이름을 변경하십시오.",
    "error2008": "이 장치는 이미 다른 그룹에 연결되어 있습니다",
    "notDevicesName": "장치 이름을 비울 수 없습니다",
    "notDevicesNO": "장치 ID를 비울 수 없습니다",
    "dialogDevicesName": "장치 이름:",
    "dialogDevicesID": "장치 ID:",
    "dialogProjectorCode": "시리얼 코드:",
    "dialogGroup": "그룹:",
    "dialogSel": "선택하세요",
    "errorOrgIdList": "그룹은 비울 수 없습니다!",
    "errorDevicesName": "장치 이름을 비울 수 없습니다!",
    "errorDevicesNo": "장치 ID를 비울 수 없습니다!",
    "dialogTiltleDevices": "장치:",
    "uploadSuccess": "업로드 성공",
    "addSuccess": "추가 성공",
    "ChooseGroups": "그룹 선택",
    "ChooseIcon": "아이콘 선택",
    "dialogDevicesTitle": "이 매개변수 설정은 다음 장치에 적용됩니다",
    "backDevice": "뒤로",
    "bootSetting": "시작 옵션",
    "nmpOpenSetting": "전원 켜기 설정",
    "npsOpenSetting": "전원 켜기 설정",
    "nmpPowerSettings": "전원 설정",
    "npsPowerSettings": "전원 설정",
    "nmpInterfaceSettings": "인터페이스 설정",
    "npsInterfaceSettings": "인터페이스 설정",
    "nmpDefaultChannel": "기본 채널 설정",
    "nmpCloseSetting": "전원 끄기 설정",
    "npsCloseSetting": "전원 끄기 설정",
    "SwipeToStart": "잠금 활성화(카드로 탭하여 잠금 해제)",
    "ControlPanelToStart": "잠금 비활성화(무제한 작동)",
    "Display": "디스플레이",
    "External": "외부",
    "startingUpMethod": "패널 잠금 활성/비활성:",
    "startWith": "시작 시:",
    "nmpstartWith": "전원 켜기 동기화:",
    "nmpcloseWith": "전원 끄기 동기화:",
    "RS232Tip": "메인 전원이 꺼지면 Serial 인터페이스 5개(Serial + 최대 4 CBX)에 해당 종료 명령 코드가 전송됩니다",
    "startPowerTip": "전원 켜기 시 CBX 전원 포트에 연결된 모든 장치가 켜집니다.",
    "startAirTip": "전원 켜기 시 모든 연결된 에어컨이 장치/CBX의 적외선 신호로 켜집니다.",
    "startIrTip": "전원 켜기 시 명령(예: 스크린 접기, 프로젝터 끄기)이 장치/CBX의 적외선 신호로 전송됩니다.",
    "startRSTip": "전원 켜기 시 전원 켜기 명령이 장치/CBX의 Serial 포트로 전송됩니다.",
    "CloseDisplayTip": "DISPLAY 포트에 연결된 디스플레이는 NDP/NMP 종료 시 자동으로 꺼집니다. 이 설정은 펌웨어로 관리되며 소프트웨어로 변경할 수 없습니다.",
    "CloseExternalTip": "EXTERNAL 포트에 연결된 장치는 NDP/NMP 종료 시 자동으로 꺼집니다. 이 설정은 펌웨어로 관리되며 소프트웨어로 변경할 수 없습니다.",
    "ClosePowerTip": "종료 시 CBX 전원 포트에 연결된 모든 장치가 꺼집니다.",
    "CloseAirTip": "종료 시 모든 연결된 에어컨이 장치/CBX의 적외선 신호로 켜집니다.",
    "CloseIrTip": "종료 시 명령(예: 스크린 접기, 프로젝터 끄기)이 장치/CBX의 적외선 신호로 전송됩니다.",
    "CloseRSTip": "종료 시 종료 명령이 장치/CBX의 Serial 포트로 전송됩니다.",
    "npsOpenRS232Tip": "메인 전원이 켜지면 NPS의 두 Serial 포트가 해당 전원 켜기 명령 코드를 받습니다.",
    "npsRS232Tip": "메인 전원이 꺼지면 NPS의 두 Serial 인터페이스가 해당 종료 명령 코드를 받습니다.",
    "useCardTip": "카드 잠금 해제 후 장치 전원이 자동으로 켜집니다.",
    "npsCardTip": "카드 잠금 해제 후 장치 메인 전원이 자동으로 켜집니다.",
    "PowerOutageHandling": "정전 처리",
    "PowerOutageHandTip": "예기치 않은 정전 중에도 계속 액세스하려면 '정전 시 잠금 해제'를 선택하세요. 그렇지 않으면 '정전 시 잠금'을 선택하여 액세스를 제한하세요",
    "acSetting": "에어컨 설정",
    "ChooseType": "장치 유형",
    "ChooseBrand": "브랜드 선택",
    "ChooseModel": "모델 선택",
    "btnConnectingTest": "연결 테스트",
    "LockSetting": "전기 잠금 설정",
    "ElectricLockType": "전기 잠금 유형:",
    "PowerUNLOCK": "정전 시 해제",
    "PowerLOCK": "정전 시 잠금",
    "none": "없음",
    "oddParity": "홀수 패리티",
    "EvenParity": "짝수 패리티",
    "LastSetting": "마지막 설정",
    "ElectricLockClosing": "전기 잠금 닫기:",
    "manualSwitch": "수동 스위치",
    "Auto": "자동 (in",
    "projectorSetting": "장치 선택 및 바인딩",
    "baudRate": "보드율",
    "Parity": "패리티",
    "ON": "전원 켜기",
    "OFF": "전원 끄기",
    "Channel1": "채널 1",
    "Channel2": "채널 2",
    "PowerOffDelay": "전원 끄기 지연",
    "second": "초",
    "DefaultChannel": "기본 채널",
    "HDMIA": "HDMI 출력 A:",
    "HDMIB": "HDMI 출력 B:",
    "HDMIC": "HDMI 출력 C:",
    "btnSaveApply": "저장 및 적용...",
    "btnSave": "저장",
    "btnCustomize": "사용자 정의",
    "ACIsPowerTitle": "에어컨이 켜져 있는지 확인하시겠습니까?",
    "ACIsPowerContent": "테스트 전에 에어컨을 끄세요. 정상적으로 켜지지 않으면, 에어컨 브랜드와 모델이 올바른지 확인하세요.",
    "btnNextModel": "아니요, 다음 모델 테스트",
    "btnYes": "예",
    "errorConnecting": "연결 테스트 실패",
    "hot": "HOT",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "전자 잠금",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AUDIOA": "HDMI out A",
    "_AUDIOB": "Audio IN 1",
    "_AUDIOC": "Audio IN 2",
    "_AIR": "에어컨",
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "IR 제어 설정",
    "acControlTitle": "A/C 장치 선택:",
    "acControlTitleNew": "A/C 장치",
    "intelligentControlTitle": "리모컨 장치 선택:",
    "intelligentControlTitleNew": "리모컨 장치",
    "btnACControlCode": "새 A/C 제어 코드 식별",
    "btnAddRemoteControl": "새 리모컨 코드",
    "ACControlCodeTitle": "A/C 제어 코드 식별",
    "ACControlCodeseft1": "코드 식별",
    "ACControlCodeseft2": "정보 추가",
    "btnStartIdentify": "시작",
    "Identifysuccess": "식별 성공!",
    "BeingIdentify": "분석 중...",
    "acBrand": "A/C 브랜드",
    "acModel": "A/C 모델",
    "IdentifyFailureTitle": "코드를 찾을 수 없음",
    "IdentifyFailureContent": "식별에 실패했습니다. 이 모델은 현재 지원되지 않습니다. 리모컨을 사용해 보세요",
    "btnTryAgain": "다시 시도",
    "btnJump": "리모컨으로 이동",
    "ACrideo": "A/C",
    "ortherRideo": "기타 장치",
    "btnBack": "뒤로",
    "btnSortOut": "편집으로 이동",
    "remoteControlSeft1": "장치 유형 선택",
    "remoteControlSeft2": "코드 학습",
    "remoteControlSeft3": "정보 추가",
    "addRemoteControlError": "죄송합니다, 더 이상 코드를 학습할 수 없습니다. 기존 리모컨 코드를 먼저 편집하세요",
    "btnPrevious": "이전",
    "btnNextStep": "다음",
    "remoteControlErrorTitle": "코드 학습 실패",
    "remoteControlErrorContent1": "1. 적외선 송신기가 막혀 있지 않은지 확인",
    "remoteControlErrorContent2": "2. 수신기 주변에 강한 빛 간섭이 없는지 확인",
    "remoteControlErrorContent3": "3. 적외선 송신기가 올바르게 설치되었는지 확인",
    "remoteControlErrorContent4": "4. 리모컨이 정상 작동하는지 확인",
    "deviceItem1": "A/C",
    "deviceItem2": "프로젝터",
    "deviceItem3": "TV",
    "deviceItem4": "선풍기",
    "deviceItem5": "조명",
    "deviceItem6": "기타",
    "deviceItem7": "인터랙티브 플랫 패널",
    "deviceItem8": "강의 녹화 시스템",
    "deviceItem9": "PTZ 카메라",
    "RS232protocol": "시리얼 프로토콜:",
    "btnRemoteControl": "학습 시작",
    "BeingIdentify1": "분석 중...",
    "Identifysuccess1": "성공",
    "controllerType1": "A/C",
    "controllerType2": "시리얼",
    "controllerType3": "TV",
    "controllerType4": "선풍기",
    "controllerType5": "조명",
    "controllerType9": "기타",
    "rqRemoteControlCode": "리모컨 코드 이름을 입력하세요",
    "rqBrand": "A/C 브랜드를 입력하세요",
    "rqModel": "A/C 모델을 입력하세요",
    "error2016": "리모컨 이름이 중복되었습니다. 다른 이름을 입력하세요",
    "RS232Setting": "시리얼 코드 설정",
    "IR232Setting": "IR 설정",
    "SystemError": "시스템 오류. 다시 시도하세요",
    "conditionerCodeContent": "에어컨 코드를 찾을 수 없습니다. 다시 시도하세요",
    "remoteControlCodeContent": "리모컨 코드를 찾을 수 없습니다. 다시 시도하세요",
    "btnRetry": "재시도",
    "Bindusers": "사용자 바인딩",
    "tablebinduser": "사용자 바인딩",
    "Refresh": "새로고침",
    "Binduserlable": "지금 장치를 제어할 수 있는 사용자를 바인딩하시겠습니까?",
    "SaveApplySuccessfully": "저장 및 적용 성공",
    "DeviceType": "타입:",
    "tableDeviceType": "타입",
    "empty": "비어 있습니다.",
    "sendCommand": "나중에 전송",
    "enable": "활성화",
    "disable": "비활성화",
    "SYNCremoteControl": "리모컨과 동기화",
    "analysisfailed": "분석 실패, 다시 시도하세요!",

    "CBX": {
      "powerSupplyON": "전원 켜기",
      "powerSupplyOFF": "전원 끄기",
      "powerVcrON": "녹화 시작",
      "powerVcrOFF": "녹화 중지",
      "lockScreenON": "잠금 켜기",
      "lockScreenOFF": "잠금 끄기",
      "childLockON": "어린이 잠금 켜기",
      "childLockOFF": "어린이 잠금 끄기",
      "energySavingON": "절전 켜기",
      "energySaving": "절전",
      "energySavingOFF": "절전 끄기",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "스피커",
      "brightAdjustment": "밝기",
      "other": "기타 기능…",
      "volumeExample": "녹화 시스템과 완전 호환을 위해 RS232 제어 기능이 필요합니다.",
      "functionCode": "기능：",
      "Name": "이름：",
      "controlCode": "제어 코드：",
      "brand": "브랜드：",
      "model": "모델：",
      "errorBrandName": "브랜드를 입력해야 합니다!",
      "errorModelName": "모델을 입력해야 합니다!"
    }
  },
  "roleMge": {
    "role1": "일반 사용자",
    "role101": "에이전트 관리자",
    "role102": "관리자",
    "role4": "사용자 정의 역할",
    "roleNew": "새 역할",
    "btnAddRole": "역할 추가",
    "chooseUser": "사용자 선택",
    "titleLevel": "방송 속성 수준:",
    "titleSettings": "권한 설정:",
    "btnSave": "저장",
    "btnDelete": "삭제",
    "cancel": "취소",
    "confirm": "확인",
    "save": "저장",
    "addSuccess": "추가 성공!",
    "addError": "추가 실패!",
    "editSuccess": "편집 성공!",
    "editError": "편집 실패!",
    "delSuccess": "삭제 성공!",
    "delError": "삭제 실패!",
    "V3_0_OrganizationManage": "그룹 관리",
    "V3_0_UserManage": "사용자 관리",
    "V3_0_DeviceManage": "장치 관리",
    "V3_0_CloudSpaceManage": "클라우드 공간 관리",
    "V3_0_OrganizationManage_View": "보기",
    "V3_0_OrganizationManage_Edit": "편집",
    "V3_0_UserManage_View": "보기",
    "V3_0_UserManage_Edit": "편집",
    "V3_0_DeviceManage_AddDevice": "장치 추가",
    "V3_0_DeviceManage_Operating": "작업",
    "V3_0_DeviceManage_Delete": "삭제",
    "V3_0_DeviceManage_Edit": "편집",
    "V3_0_CloudSpaceManage_PersonalManage": "개인 클라우드 관리",
    "V3_0_CloudSpaceManage_PublicManage": "공용 클라우드 관리",
    "V3_0_CloudSpaceManage_SpaceManage": "공간 할당",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "작업",
    "V3_0_CloudSpaceManage_PersonalManage_View": "보기",
    "V3_0_CloudSpaceManage_PublicManage_View": "보기",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "업로드",
    "V3_0_CloudSpaceManage_PublicManage_Download": "다운로드",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "파일 삭제",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "폴더 편집",
    "delTitle": "삭제?",
    "delTitleContent": "선택한 내용이 데이터베이스에서 삭제됩니다. 이 작업은 되돌릴 수 없습니다. 계속하시겠습니까?",
    "delCancelButton": "취소",
    "delConfirmButton": "확인",
    "btnAdd": "역할 추가",
    "RoleName": "역할 이름:",
    "ManageRange": "관리 범위:",
    "ChooseUser": "사용자 선택:",
    "PermissionSettings": "권한 설정:",
    "BroadcastingPropertyLevel": "방송 속성 수준",
    "ChooseGroups": "그룹 선택",
    "ChooseTheUser": "사용자 선택",
    "deleleTitle": "새 역할이 저장되지 않았습니다. 나가면 역할이 삭제됩니다. 정말 나가시겠습니까?",
    "Error1601": "관리자는 사용할 수 없습니다",
    "Error1602": "권한 역할 가져오기 실패",
    "Error1603": "이 기능은 관리자만 접근할 수 있습니다",
    "Error1604": "역할 이름은 비워둘 수 없습니다",
    "Error1605": "그룹은 비워둘 수 없습니다",
    "Error1606": "이 역할은 이미 존재합니다",
    "Error1607": "시스템 정의 역할은 수정할 수 없습니다",
    "Error1608": "역할 설정 실패",
    "Error1609": "시스템 공통 사용자 역할은 수정할 수 없습니다",
    "Error1610": "관련 작업은 단말 관리자 역할로 수행하십시오",
    "Error1611": "관련 역할 권한이 없습니다"
  },
  "projectorDevicesMge": {
    "tipOne": "1. 기능 이름과 제어 코드를 입력하세요. 제어 코드 예시는 HEX 형식입니다.",
    "tipTwo": "2. 이 인터페이스는 전원 ON/OFF 시리얼 명령만 구성합니다. 기능을 활성화하려면 '장비 관리 / 장비 / 작업 / 전원 설정'으로 이동하세요.",
    "tipFunctionOne": "1. 드롭다운 목록에서 자주 사용하는 기능을 선택하세요. 해당 아이콘이 스마트 패널의 시리얼 제어 인터페이스에 표시됩니다.",
    "tipFunctionTwo": "2. 'POWER ON' 및 'POWER OFF' 명령은 장비 전원 ON/OFF 시리얼 연동에 사용됩니다. 이 페이지에서는 제어 코드만 구성합니다. 연동 기능을 활성화하려면 '장비 관리 / 장비 / 작업 / 전원 설정'으로 이동하세요.",
    "ListRS232functions": "시리얼 제어 기능 목록",
    "Customizefunctionlist": "기능 목록 사용자 정의",
    "btnAddProjectorCode": "시리얼 코드 추가",
    "btnDel": "삭제",
    "inputSeach": "검색",
    "btnEdit": "편집",
    "cancel": "지우기",
    "confirm": "확인",
    "tableName": "코드 이름",
    "tablersType": "장치 유형:",
    "tablersTypeTable": "장치 유형",
    "tableModel": "모델",
    "tableBrand": "브랜드",
    "tableActions": "작업",
    "dialogAddTitle": "시리얼 코드 추가",
    "dialogEditTitle": "시리얼 코드 편집",
    "brand": "브랜드 이름:",
    "model": "모델:",
    "baudRate": "보드율:",
    "parity": "패리티:",
    "powerOn": "켬",
    "powerOff": "끔",
    "pgrInput1": "채널 1",
    "pgbInput2": "채널 2",
    "delTitle": "삭제?",
    "delTitleContent": "선택한 내용이 데이터베이스에서 삭제됩니다. 이 작업은 되돌릴 수 없습니다. 계속하시겠습니까?",
    "delCancelButton": "취소",
    "delConfirmButton": "확인",
    "content": "검색",
    "operate": "작업",
    "tableDel": "삭제",
    "tableEdit": "편집",
    "addSuccess": "추가 성공!",
    "addError": "추가 실패!",
    "editSuccess": "편집 성공!",
    "editError": "편집 실패!",
    "delSuccess": "삭제 성공!",
    "delError": "삭제 실패!",
    "selectTitle": "시리얼을 선택하십시오!",
    "selectCode": "시리얼 선택",
    "none": "없음",
    "oddParity": "홀수 패리티",
    "EvenParity": "짝수 패리티"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "그룹 관리",
    "V3_0_UserManage": "사용자 관리",
    "V3_0_DeviceManage": "장치 관리",
    "V3_0_CloudSpaceManage": "클라우드 공간 관리",
    "V3_0_OrganizationManage_View": "보기",
    "V3_0_OrganizationManage_Edit": "편집",
    "V3_0_UserManage_View": "보기",
    "V3_0_UserManage_Edit": "편집",
    "V3_0_DeviceManage_AddDevice": "장치 추가",
    "V3_0_DeviceManage_Operating": "작업",
    "V3_0_DeviceManage_Delete": "삭제",
    "V3_0_DeviceManage_Edit": "편집",
    "V3_0_DeviceManage_RepairLog": "수리 로그",
    "V3_0_CloudSpaceManage_PersonalManage": "개인 클라우드 관리",
    "V3_0_CloudSpaceManage_PublicManage": "공용 클라우드 관리",
    "V3_0_CloudSpaceManage_SpaceManage": "클라우드 공간 관리",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "작업",
    "V3_0_CloudSpaceManage_PersonalManage_View": "보기",
    "V3_0_CloudSpaceManage_PublicManage_View": "보기",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "업로드",
    "V3_0_CloudSpaceManage_PublicManage_Download": "다운로드",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "삭제",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "편집",
    "delTitle": "삭제?",
    "delTitleContent": "선택한 구성 요소가 데이터베이스에서 삭제됩니다. 이 작업은 되돌릴 수 없습니다. 계속하시겠습니까?",
    "delCancelButton": "취소",
    "delConfirmButton": "확인",
    "content": "검색",
    "operate": "작업",
    "tableDel": "삭제",
    "tableEdit": "편집",
    "addSuccess": "추가 성공!",
    "addError": "추가 실패!",
    "editSuccess": "편집 성공!",
    "editError": "편집 실패!",
    "delSuccess": "삭제 성공!",
    "delError": "삭제 실패!",
    "selectTitle": "시리얼을 선택하십시오!"
  },
  "workstationMge": {
    "priorChoice": "방송 환경 설정：",
    "SpeedPriority": "속도 우선",
    "SyncPriority": "프레임 동기 우선",
    "SpeedPriorityTip": "AV 방송 지시가 전송된 후, Q-NEX 단말기는 약 3~5초의 버퍼 시간으로 재생 작업을 수행할 수 있습니다. 미디어 서버가 LAN에서 동작하는 경우 속도 우선이 강력히 권장됩니다.",
    "SyncPriorityTip": "AV 방송 지시가 전송된 후, Q-NEX 단말기는 약 8~12초의 버퍼 시간으로 동기 재생 작업을 수행할 수 있습니다.",
    "btnAddMedia": "미디어 서버 추가",
    "btnBack": "뒤로",
    "tableMediaLibId": "미디어 서버 ID",
    "tableMediaLibName": "미디어 서버 이름",
    "tableState": "네트워크 상태",
    "tableBindingUsers": "바인딩 사용자",
    "tableLiveAddress": "스트리밍 주소",
    "tableAddress": "방송 주소",
    "tableOperate": "작업",
    "tableDel": "삭제",
    "tableEdit": "편집",
    "titleMediaStation": "방송 주소",
    "titleLiveStation": "스트리밍 주소：",
    "radioPublic": "공용",
    "radioPrivate": "개인",
    "btnSave": "저장",
    "titleUsers": "사용자",
    "titleCanBe": "바인딩 가능",
    "titleHaveBeen": "이미 바인딩됨",
    "titleMore": "더 추가해야 합니까?",
    "btnAdd": "추가",
    "content": "검색",
    "tableName": "이름",
    "tableUserName": "사용자 이름",
    "operate": "작업",
    "affiliatedOrganization": "그룹",
    "dialogTitle": "새 미디어 서버 추가",
    "dialogTitleEdit": "새 미디어 서버 편집",
    "dialogItemName": "이름：",
    "dialogItemId": "ID：",
    "dialogItemIp": "방송 주소：",
    "titleSelectUsers": "사용자 선택",
    "selectMedia": "미디어를 선택하십시오",
    "delTitle": "정말 삭제하시겠습니까?",
    "delMediaLibTitle": "삭제 확인？",
    "delTitleContent": "선택된 내용이 데이터베이스에서 삭제됩니다. 이 작업은 취소할 수 없습니다. 계속하시겠습니까?",
    "delTitleMediaLibContent": "삭제 작업으로 관련 데이터가 지워지며 복구할 수 없습니다.",
    "delCancelButton": "취소",
    "delConfirmButton": "확인",
    "selectDevices": "장치를 선택하십시오",
    "selectUser": "사용자를 선택하십시오",
    "addUser": "사용자 추가",
    "editUser": "사용자 편집",
    "addSuccess": "추가 성공!",
    "addError": "추가 실패!",
    "editSuccess": "편집 성공!",
    "editError": "편집 실패!",
    "delSuccess": "삭제 성공!",
    "delError": "삭제 실패!",
    "cancel": "취소",
    "confirm": "확인",
    "save": "저장",
    "error2500": "현재 작업 스테이션에 연결할 수 있는 장치 최대 수를 초과했습니다.",
    "DeviceName": "장치 이름",
    "AssociatedUserManagement": "연관 사용자 관리",
    "btnDel": "삭제",
    "errorMsgId": "이 ID를 찾을 수 없습니다",
    "LiveStreaming": "스트리밍 주소：",
    "NoFoundMediaId": "미디어 서버의 ID를 가져올 수 없습니다",
    "AlreadyConnectedOrg": "미디어 서버는 이미 다른 조직에 연결되어 있습니다",
    "AlreadyBoundMedia": "이 조직은 이미 미디어 서버를 바인딩했으므로 추가 바인딩할 수 없습니다",
    "DeleteSecondaryConfirmation": "미디어 서버를 삭제하면 데이터가 복구되지 않습니다. 다시 확인하십시오."
  },
  "cloudDiskMge": {
    "totalStorage": "총 스토리지",
    "GetMore": "더 받기",
    "StorageSpace": "스토리지 공간",
    "Adjustment": "조정",
    "moreSpace": "스토리지 공간 더 받기",
    "PublicStorage": "공용 스토리지",
    "PublicStorageUsed": "사용된 공용 스토리지",
    "PublicStorageLasted": "남은 공용 스토리지",
    "IndividualStorageUsed": "사용된 개인 스토리지",
    "IndividualStorageLasted": "남은 개인 스토리지",
    "storageSpace": "스토리지 공간 조정",
    "tableUserName": "사용자 이름",
    "tableUsedSpace": "사용 공간",
    "tableAvailableSpace": "사용 가능 공간",
    "tableActiveTime": "마지막 활동 시간",
    "tableOperate": "작업",
    "cleanup": "정리 주의",
    "IndividualStorageSpaceAdjustment": "개인 스토리지 공간 조정",
    "titleTotal": "총계",
    "PublicDisk": "공용 클라우드",
    "IndividualDisk": "개인 클라우드",
    "PerUser": "사용자별",
    "UsersInTotal": "총 사용자 수",
    "cancel": "취소",
    "confirm": "확인",
    "save": "저장",
    "addSuccess": "추가 성공!",
    "addError": "추가 실패!",
    "editSuccess": "편집 성공!",
    "editError": "편집 실패!",
    "delSuccess": "삭제 성공!",
    "delError": "삭제 실패!",
    "error3000": "총 스토리지 용량을 초과하여 작업에 실패했습니다.",
    "error3003": "작업 실패, 미디어 서버가 설정되었는지 확인하세요.",
    "IndividualStorage": "개인 스토리지",
    "NoteToCleanup": "정리 주의",
    "updatePersonalSuccess": "클라우드 스토리지 공간이 가득 찼습니다. 제때 정리하세요",
    "updatePersonalSuccess1": "수정 사항 저장 성공",
    "storageUsage": "개인 스토리지 사용량",
    "bindIndividualstorage": "개인 클라우드 스토리지를 사용할 수 있는 사용자",
    "UserIndividualstorage": "이미 개인 클라우드 스토리지가 설정된 사용자",
    "Notificationsuccessfully": "알림 전송 성공",
    "Notificationfailed": "알림 전송 실패",
    "tableName": "이름",
    "userID": "사용자 ID"
  },
  "dashboard": {
    "exportPdf": "PDF 내보내기",
    "or": "-",
    "warrantyCompletionRate": "수리 완료율",
    "frequencyOfEachModule": "각 기능 모듈의 수리 비율",
    "repairHandling": "수리 처리 상태",
    "sourceSwitchInput": "입력 스위치",
    "micVol": "마이크 볼륨",
    "volumeSpeaker": "스피커 볼륨",
    "airAonditioner": "에어컨",
    "Curtain": "프로젝터 스크린",
    "remoteControlIntelligent": "리모컨",
    "RS232Control": "시리얼 제어",
    "lockElectronic": "전자 잠금장치",
    "Repairreportcompleted": "수리 완료",
    "Totalnumberofrepairsreported": "총 수리",
    "Warrantycompletionrate": "수리 완료율",
    "startDate": "시작일",
    "endDate": "종료일",
    "year": "년",
    "month": "월",
    "dayTian": "일",
    "placeholderDate": "날짜 선택",
    "placeholderDateTime": "시간 선택",
    "devicesNub": "디바이스",
    "userNub": "사용자",
    "powerNub": "전력(KW/H)",
    "storageUsed": "사용된 저장 공간(%)",
    "userLoginDevice": "사용자 로그인 활성 시간",
    "devicePowerConsumption": "모든 디바이스의 일일 전력 소비량",
    "externalDeviceUsageTime": "외부 디바이스 사용",
    "equipmentRunningTime": "터미널 디바이스 사용",
    "cloudStorageSpace": "저장 공간 사용량",
    "powerConsumptionPort": "각 전원 포트의 전력 소비",
    "mostPopularFile": "가장 인기 있는 파일",
    "commonFunctions": "자주 사용하는 기능",
    "commonlyUsed": "자주 사용하는 방송 방식",
    "fileName": "파일 이름",
    "usageCount": "사용 횟수",
    "electricityConsumption": "전력 소비량",
    "publicStorageUsed": "공용 저장소 사용",
    "publicStorageLasted": "공용 저장소 남음",
    "individualStorageUsed": "개인 저장소 사용",
    "individualStorageLasted": "개인 저장소 남음",
    "notification": "알림",
    "audioBroadcast": "오디오 방송",
    "videoBroadcast": "비디오 방송",
    "ac": "에어컨",
    "hDMISwitch": "HDMI 스위치",
    "powerControl": "전원 제어",
    "powercontrol": "전원 제어",
    "Lock": "잠금",
    "volumeAdjust": "볼륨 조절",
    "projectionScreen": "투사 화면",
    "today": "오늘",
    "yesterday": "어제",
    "thisWeek": "이번 주",
    "lastWeek": "지난 주",
    "lastMonth": "지난 달",
    "thisMonth": "이번 달",
    "times": "횟수",
    "usage": "사용 횟수",
    "eachrTitle": "분",
    "total": "총합",
    "NMPSystemissue": "NMP 시스템 문제",
    "displayPower": "NMP 외부 디바이스 문제",
    "externalPower": "MBX 시스템 문제",
    "screen": "MBX 외부 디바이스 문제",
    "TotalRepairs": "총 수리",
    "Repaired": "수리 완료",
    "Unrepaired": "수리 미완료",
    "day": "일",
    "Minutes": "분",
    "powerConsumption": "분",
    "Date": "날짜",
    "kw": "KW",
    "month1": "MON",
    "month2": "TUE",
    "month3": "WED",
    "month4": "THU",
    "month5": "FRI",
    "month6": "SAT",
    "month7": "SUN",
    "enmonth1": "Jan",
    "enmonth2": "Feb",
    "enmonth3": "Mar",
    "enmonth4": "Apr",
    "enmonth5": "May",
    "enmonth6": "Jun",
    "enmonth7": "Jul",
    "enmonth8": "Aug",
    "enmonth9": "Sep",
    "enmonth10": "Oct",
    "enmonth11": "Nov",
    "enmonth12": "Dec",
    "noData": "데이터 없음"
  },
  "input": {
    "fivedigits": "5자리 이하의 양의 정수를 입력하세요",
    "titlUserNameField": "이 사용자 이름은 필수입니다.",
    "thisField": "이 필드는 필수입니다.",
    "ChooseGroup": "그룹 선택",
    "placeholder": "선택",
    "placeholder_type": "디바이스 제어 유형을 선택하세요",
    "titlRealNameField": "비밀번호는 필수입니다.",
    "thisPasswordField": "비밀번호는 필수입니다.",
    "titlPassWordNub": "15자 미만",
    "Post": "숫자만",
    "passwordNoChinese": "이 입력란에는 한글을 입력할 수 없습니다"
  },
  "transfer": {
    "all": "전체",
    "Choose": "선택",
    "Selected": "선택됨",
    "Subordinate": "하위"
  },
  "setting": {
    limitPngGif: 'PNG / GIF 형식만 지원됩니다',
    limit3M: '이미지 크기는 3MB를 초과할 수 없습니다',
    setting_door_Wallpaper_text: '권장 이미지 크기: 1280x800, PNG 또는 GIF 형식',

    "reduction": "복원",
    "limitJpg": "업로드된 프로필 사진은 PNG 형식만 지원됩니다!",
    "limit2M": "업로드된 프로필 사진의 크기는 2MB를 초과할 수 없습니다!",
    "choseFile": "파일 선택",
    "textOne": "1. 권장 LOGO 이미지: 117*40 크기, PNG 형식",
    "textTwo": "2. 업로드 완료 후 터치 패널로 이동하여 터치 패널이 인터넷에 연결되어 있는지 확인한 후, 원래 로고를 클릭하여 새로고침하십시오.",
    "customizeLogo": "터치 패널 로고 설정",
    "addSuccess": "설정 완료!",
    "settingIp": "파일 저장소 IP 설정",
    "ServerIP": "서버 IP 주소:",
    "ServerPort": "서버 포트:",
    "btnSave": "저장",
    "TimeZoneSetting": "시간대 설정",
    "CurrentTime": "현재 시간:",
    "CurrentTimeZone": "현재 시간대:",
    "httpsSetting": "파일 저장소:",
    "utcName": "그리니치 표준시 UTC/GMT",
    "utc0": "그리니치 표준시, 영국, 리스본, 토르샤운, 런던, 더블린, 에든버러",
    "utc0_5": "",
    "utc1": "중앙 유럽, 서아프리카, 서중부 아프리카, 독일, 아일랜드, 프랑스, 암스테르담, 이탈리아, 베를린, 로마, 스페인, 프라하, 베오그라드, 브뤼셀, 파리, 마드리드, 튀니지, 가봉, 모로코",
    "utc1_5": "",
    "utc2": "동유럽, 중앙아프리카, 터키, 이스라엘, 남아프리카, 이스탄불, 카이로, 아테네, 다마스쿠스",
    "utc2_5": "",
    "utc3": "동아프리카, 러시아, 바그다드, 쿠웨이트, 모스크바, 상트페테르부르크",
    "utc3_5": "이란",
    "utc4": "아부다비, 트빌리시, 두바이, 모리셔스, 포트루이스",
    "utc4_5": "아프가니스탄",
    "utc5": "파키스탄, 투르크메니스탄, 몰디브, 우즈베키스탄, 아르메니아, 타지키스탄, 인도(뭄바이, 뉴델리, 벵갈루루, 콜카타)",
    "utc5_5": "인도, 스리랑카",
    "utc6": "노보시비르스크, 키르기스스탄, 방글라데시, 부탄",
    "utc6_5": "코코스 제도, 호주, 베트남",
    "utc7": "태국(방콕), 하노이, 자카르타",
    "utc7_5": "",
    "utc8": "중국, 말레이시아, 필리핀, 싱가포르, 대만, 중국(마카오), 중국(홍콩)",
    "utc8_5": "",
    "utc9": "일본, 한국, 도쿄, 서울, 삿포로, 오사카, 동티모르",
    "utc9_5": "호주 중앙 표준시",
    "utc10": "호주, 블라디보스토크, 괌, 캔버라, 멜버른, 시드니, 파푸아뉴기니",
    "utc10_5": "호주 뉴사우스웨일스 로드하우 섬",
    "utc11": "솔로몬 제도, 사할린",
    "utc11_5": "노퍽 섬, 호주",
    "utc12": "뉴질랜드, 오클랜드, 웰링턴, 피지, 뉴질랜드, 나우루",
    "utc12_5": "",
    "utc13": "카보베르데, 아조레스",
    "utc13_5": "",
    "utc14": "사우스조지아, 페르난도 데 노로냐",
    "utc14_5": "",
    "utc15": "브라질, 산티아고, 엘살바도르, 브라질리아, 우루과이, 아르헨티나, 수리남",
    "utc15_5": "뉴펀들랜드 표준시",
    "utc16": "베네수엘라, 볼리비아, 파라과이, 칠레",
    "utc16_5": "베네수엘라",
    "utc17": "미국 및 캐나다 동부 시간, 콜롬비아, 토론토, 에콰도르, 페루, 쿠바, 뉴욕, 해밀턴, 샌디에이고",
    "utc17_5": "",
    "utc18": "미국 및 캐나다 중부 시간, 멕시코시티, 몬테레이, 시카고, 휴스턴, 뉴올리언스, 멤피스",
    "utc18_5": "",
    "utc19": "산악 시간, 애리조나, 마자틀란, 피닉스, 솔트레이크시티, 덴버, 에드먼턴",
    "utc19_5": "",
    "utc20": "태평양 시간, 로스앤젤레스, 샌프란시스코, 밴쿠버, 시애틀, 라스베이거스",
    "utc20_5": "",
    "utc21": "알래스카",
    "utc21_5": "프랑스령 폴리네시아, 마르케사스 제도",
    "utc22": "하와이",
    "utc22_5": "",
    "utc23": "사모아, 뉴에",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "장치 이름:",
    "Time": "시간:",
    "startDate": "시작일",
    "endedDate": "종료일",
    "or": "-",
    "Problem": "문제:",
    "btnSearch": "검색",
    "tableNO": "아니오",
    "tableDeviceName": "장치 이름",
    "tableGroup": "그룹",
    "tableStatus": "상태",
    "tableDeliveredTime": "배달 시간",
    "tableSubmitter": "제출자",
    "tableUpdatingTime": "업데이트 시간",
    "tableProblem": "문제",
    "tableAdmin": "IT 관리자",
    "tableAdminReply": "관리자 답변",
    "tableAttachment": "첨부",
    "state0": "배달됨",
    "state1": "진행 중",
    "state2": "완료",
    "Problem100": "전체",
    "Problem0": "시스템 문제",
    "Problem1": "외부 장치 문제",
    "ProblemType": "",
    "ProblemType0": "전원 제어",
    "ProblemType1": "HDMI 스위치",
    "ProblemType2": "마이크",
    "ProblemType3": "스피커",
    "ProblemType4": "에어컨",
    "ProblemType5": "프로젝터 화면",
    "ProblemType6": "전자 잠금장치",
    "ProblemType7": "A/V 방송",
    "ProblemType8": "IR 제어",
    "ProblemType9": "시리얼 제어",
    "dialogDeviceName": "장치 이름",
    "dialogDeviceID": "장치 ID",
    "dialogGroup": "그룹",
    "dialogSubmitter": "제출자",
    "dialogStatus": "상태 선택",
    "dialogProblem": "문제",
    "dialogNotes": "메모",
    "dialogRepairation": "수리",
    "dialogInProcess": "진행 중",
    "dialogCompleted": "완료",
    "editSuccess": "편집 성공!",
    "editError": "편집 실패!",
    "problemRequired": "문제 유형을 선택하세요",
    "detailRequired": "문제를 자세히 설명하세요",
    "statusRequired": "로그 상태를 선택하세요",
    "btnCancel": "취소",
    "DeliveredTime": "배달 시간",
    "UpdatingTime": "업데이트 시간",
    "ITAdmin": "IT 관리자",
    "AdminReply": "관리자 답변",
    "Note": "메모",
    "Detail": "세부 정보",
    "controlPanel": "제어판",
    "DeviceType": "유형",
    "dialogDeliveredTime": "배달 시간",
    "Submitter": "제출자"
  },
  "remoteControl": {
    "QuickActionName": "이름",
    "DeviceType": "유형",
    "Description": "설명",
    "tableDescription": "설명",
    "editRemoteControl": "리모컨 코드 편집",
    "QuickActionNameInput": "이름",
    "DescriptionInput": "설명",
    "save": "저장",
    "Brand": "브랜드",
    "Model": "모델",
    "EditACControlCode": "에어컨 제어 코드 편집",
    "acBrand": "에어컨 브랜드",
    "acModel": "에어컨 모델"
  },
  "card": {
    "btnAddCard": "카드 추가",
    "btnBatchAddCard": "카드 일괄 추가",
    "tableCard": "카드 번호",
    "tableState": "상태",
    "tableUser": "사용자에 연결",
    "tableID": "사용자 이름",
    "tableType": "카드 유형",
    "tableFfective": "만료일",
    "dialogCard": "카드 번호：",
    "dialogState": "상태：",
    "dialogUser": "사용자에 연결：",
    "dialogID": "사용자 이름：",
    "dialogType": "카드 유형：",
    "dialogFfective": "만료일：",
    "dialogRemarks": "비고：",
    "dialogAddTitle": "카드 추가",
    "dialogEidtTitle": "카드 편집",
    "code2201": "카드 만료 기간 형식이 올바르지 않습니다",
    "code2202": "이 카드는 이미 연결되어 있습니다",
    "code2203": "이 사용자는 이미 연결되어 있습니다",
    "code2204": "이 카드는 연결되지 않았습니다",
    "mastCard": "마스터 카드",
    "regularCard": "일반 카드",
    "permanent": "영구",
    "coxPermanent": "영구",
    "coxTime": "일정 기간",
    "tableDeviceName": "장치 이름",
    "tableDeviceID": "장치 ID",
    "tableOperating": "작업",
    "tableOperatingTime": "작업 시간",
    "tableCardID": "카드 번호",
    "tableCardType": "카드 유형",
    "tabluserName": "사용자 이름",
    "tabluserId": "사용자 ID",
    "unlockPanel": "패널 잠금 해제",
    "unlock": "문 잠금 해제",
    "conAll": "전체",
    "btnEnable": "활성화",
    "btnDisable": "비활성화",
    "enableSuccess": "활성화 성공",
    "stopSuccess": "비활성화 성공",
    "enableError": "활성화 실패",
    "stopError": "비활성화 실패",
    "batchCard": "카드 번호 일괄：",
    "titlCardField": "카드 번호를 입력해야 합니다",
    "titlCardFieldFormat": "영문 및 숫자만",
    "dialogBachAddTitle": "카드 일괄 추가",
    "pleaseTryAgain1": "카드 번호 오류 (NO.：",
    "pleaseTryAgain2": "), 다시 시도하십시오"
  },

  "privacy": {
    "PrivacyPolicy": "Microsoft Organization Binding Privacy Agreement",
    "Byusing": "Dear User,",
    "whatinformation": "Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking \"Agree,\" you confirm that you have read and accepted all terms of this agreement.",
    "EffectiveDate": "Effective Date: August 4, 2025",
    "title1": "Required Permissions & Collected Data",
    "title1Respects1": "To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:",
    "title1Respects2": "Delegated Permissions",
    "Respects2formation": "These permissions allow Q-NEX to access your Microsoft account data after login and consent:",
    "Respects2formation2": "Calendars.ReadWrite",
    "Respects2formation3": "Permission Name: Full access to user calendars",
    "Respects2formation4": "Description: Allows the app to create, read, update, and delete events in user calendars.",
    "Respects2formation5": "Purpose: Synchronize personal calendar meetings with the Q-NEX system.",
    "Respects2formation6": "offline_access",
    "Respects2formation7": "Permission Name: Maintain access to data you've granted",
    "Respects2formation8": "Description: Allows the app to access authorized data even when you're not actively using it.",
    "Respects2formation9": "Purpose: Ensures meeting information remains synced even when users are offline.",
    "Respects2formation10": "Openid",
    "Respects2formation11": "Permission Name: Sign in as you",
    "Respects2formation12": "Description: Enables login via work/school accounts and allows the app to read basic profile details.",
    "Respects2formation13": "Purpose: Authenticates user identity for security and associates profiles with meeting data.",
    "Respects2formation14": "Place.Read.All",
    "Respects2formation15": "Permission Name: Read all company places",
    "Respects2formation16": "Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.",
    "Respects2formation17": "Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.",
    "tp1": "Application Permissions (Requires Admin Consent)",
    "tp2": "These permissions enable Q-NEX to sync data automatically without manual reauthorization:",
    "tp3": "Calendars.ReadWrite",
    "tp4": "Permission Name: Read and write calendars in all mailboxes",
    "tp5": "Description: Allows the app to create, read, update, and delete calendar events without user sign-in.",
    "tp6": "Purpose: Syncs schedules from all company meeting room resource mailboxes.",
    "tp7": "Directory.Read.All",
    "tp8": "Permission Name: Read directory data",
    "tp9": "Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.",
    "tp10": "Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.",
    "tp11": "User.Read.All",
    "tp12": "Permission Name: Read all users' full profiles",
    "tp13": "Description: Allows the app to read user profiles without user sign-in.",
    "tp14": "Purpose: Identifies meeting participants.",
    "tp15": "Place.Read.All",
    "tp16": "Permission Name: Read all company places",
    "tp17": "Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.",
    "tp18": "Purpose: Retrieves full meeting room resource lists and syncs availability statuses.",
    "title2": "Purpose of Data Usage",
    "title2Respects1": "Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.",
    "title2Respects2": "Automatically update room availability to prevent scheduling conflicts.",
    "title2Respects3": "Provide a unified meeting management experience.",
    "title3": "Data Storage & Protection",
    "title3Respects1": "All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.",
    "title3Respects2": "Q-NEX does not share calendar data with third parties unless legally required or for system security.",
    "title3Respects3": "For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.",
    "title4": "Your Rights",
    "title4Respects1": "You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.",
    "title5": "Important Notes",
    "title5Respects1": "Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.",
    "title5Respects2": "Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.",
    "contactInformation": "Contact Information",
    "contactInformationContent": "If you have any questions, please contact: info@qnextech.com"
  }
}



// WEBPACK FOOTER //
// ./src/lang/ko.js